import { useTranslation } from 'next-i18next';

import { Box, BoxProps, Button, JsxStyleProps, Text } from '@chakra-ui/react';

import { formatHelpers } from '@nocowanie/core';

import { apiTypes } from '@app/models';

interface RoomServicesProps extends BoxProps {
    services?: apiTypes.Maybe<apiTypes.Maybe<apiTypes.Service>[]>;
    openModal?: () => void;
    headingSize?: JsxStyleProps['fontSize'];
    listingSize?: JsxStyleProps['fontSize'];
    hideHeading?: boolean;
}

export const RoomServices = ({
    services,
    openModal,
    headingSize,
    listingSize,
    hideHeading = false,
    ...props
}: RoomServicesProps) => {
    const { t } = useTranslation('accommodation');

    const servicesString = services
        ?.map((service, i) =>
            service?.type !== apiTypes.ServiceType.Unknown
                ? `${
                      service?.type !== apiTypes.ServiceType.WiFi
                          ? formatHelpers.lowerCaseString(service?.name)
                          : service?.name
                  }${i < services.length - 1 ? ', ' : ''}`
                : null,
        )
        .join('');

    const noOfServices = services?.filter(
        service => service?.type !== apiTypes.ServiceType.Unknown,
    ).length;

    const MAX_LINE_CHARS = 40;

    return services?.length ? (
        <Box {...props}>
            {!hideHeading && (
                <Text as={'strong'} fontSize={headingSize ?? 'md'}>
                    {t('amenities.amenitiesHeader')} ({noOfServices})
                </Text>
            )}
            <Text
                lineClamp={openModal ? 1 : undefined}
                color={'gray.600'}
                fontSize={listingSize ?? 'sm'}
            >
                {servicesString}
            </Text>
            {servicesString && servicesString?.length > MAX_LINE_CHARS && !!openModal ? (
                <Button justifyContent="flex-start" variant="link" size={'xs'} onClick={openModal}>
                    {t('buttons.showAll')}
                </Button>
            ) : null}
        </Box>
    ) : null;
};
